module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('yd-slider', {
    staticClass: "borderTop",
    staticStyle: {
      "height": "4.17rem"
    },
    attrs: {
      "autoplay": "5000"
    }
  }, [_c('yd-slider-item', [_c('a', {
    attrs: {
      "href": "http://wxc76ce18c45894494.dodoca.com/authorize/redirect?param=bDhCY1c0bkNtNWlEU1RLZkx3eWVmdmNXcWk5ak9aNjlXcVNXcHFOZG9nUmF0c0s2SXplWTh0ZjVqdk5iZ3orMmlrR09VWCs4N1JPTlNPMXQ=&uid=a3NaWEN0YkR4cDdLWDM3ZWUwWQ=="
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/ronganwx/img/banner_201903282.jpg")
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be417cfe","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/IndexApply/index.vue
// module id = 30
// module chunks = 231